import { render } from "./LogoutBtn.vue?vue&type=template&id=1bb3566e&scoped=true"
import script from "./LogoutBtn.vue?vue&type=script&lang=js"
export * from "./LogoutBtn.vue?vue&type=script&lang=js"

import "./LogoutBtn.vue?vue&type=style&index=0&id=1bb3566e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb3566e"]])

export default __exports__